import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { langState, langText } from "../../recoil/lang";
import { contentName } from "../../utils/util";
import { resetRecoil } from "recoil-nexus";
import { alarmState } from "../../recoil/alarm";
import LogController from "../../controller/LogController";

const MorningCallModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  const onCloseModal = () => {
    resetRecoil(alarmState);
    oProps.setVisible(false);
    LogController.click({
      path: "MorningCallModal",
      params: "morningCall",
      params2: "사용자가 모닝콜 모달 닫음",
    });
  };

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "MorningCallModal",
        params: "morningCall",
        params2: "모닝콜 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "morningCallModalOverlay",
        modal: "morningCallModal",
      }}
      closeOnOverlayClick={true}
      showCloseIcon={true}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="닫기 아이콘"
        />
      }
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm_color.svg`}
            alt="clock"
          />
          <h2 className="titleFont">MORNING CALL</h2>
          {/* <h2>{langText.morning_call_content[lang]}</h2> */}
          <div className="confirmButton" onClick={onCloseModal}>
            OK
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default MorningCallModal;

const Style = styled.div`
  img {
    padding-bottom: 6px;
    width: 48px;
    height: 48px;
  }
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 7% 10%;
    width: 100%;
    height: 100%;
  }
  .titleFont {
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }
  h2 {
    font-weight: 400;
  }
  .confirmButton {
    margin-top: 30px;
    width: 90%;
    padding: 16px;
    background: #4dd2ae;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }
`;
